import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { BkButton } from '@brickclay-org/ui';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BkButton],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  loading: boolean;
  showUtcChangeBanner = false;
  private initialTimezoneOffset: number | null = null;
  private checkIntervalId: ReturnType<typeof setInterval> | null = null;
  private readonly visibilityHandler = () => this.checkTimezone();

  constructor(private authService: AuthService) {
    this.loading = true;
    this.authService.runInitialLoginSequence().then(() => {
      this.loading = false;
    }).catch(err => {
      console.error('Auth initialization failed', err);
      this.loading = false;
    });
    const switchTenant = localStorage.getItem('switchTenant');
    const tenant = localStorage.getItem('businessName');
    if (tenant && switchTenant) {
      localStorage.removeItem('switchTenant');
      window.location.reload();
    }
    this.loading = false;
  }

  ngOnInit(): void {
    this.initialTimezoneOffset = new Date().getTimezoneOffset();
    document.addEventListener('visibilitychange', this.visibilityHandler);
    window.addEventListener('focus', this.visibilityHandler);
    this.checkIntervalId = setInterval(() => this.checkTimezone(), 2000);
  }

  ngOnDestroy(): void {
    document.removeEventListener('visibilitychange', this.visibilityHandler);
    window.removeEventListener('focus', this.visibilityHandler);
    if (this.checkIntervalId !== null) {
      clearInterval(this.checkIntervalId);
      this.checkIntervalId = null;
    }
  }

  checkTimezone(): void {
    if (this.initialTimezoneOffset === null || document.visibilityState !== 'visible') {
      return;
    }
    const currentOffset = new Date().getTimezoneOffset();
    if (currentOffset !== this.initialTimezoneOffset) {
      this.showUtcChangeBanner = true;
    }
  }

  refreshPage(): void {
    window.location.reload();
  }
}
